/** @jsx h */
import { h } from "hyperapp";
import { unwrapNode } from "../utilities";
const noop = val => val;

/**
 * Connect
 * @param {Function} mapToProps
 */
export const connect = (mapToProps = noop) => Component => (
  props,
  children
) => (state, actions) => {
  return h(
    Component,
    {
      ...props,
      ...mapToProps(state, actions, props)
    },
    children
  );
};

/**
 * Fragment
 * @param {Object} _ Properties (ignored)
 * @param {Array} children Children to render
 */
export const Fragment = (_, children) => children;

/**
 * Wrapped SVG
 *
 * @param {String} props.data SVG as string
 */
export const WrappedSvg = ({ data, width, height }) => {
  return (
    <span
      oncreate={el => {
        el.innerHTML = data;
        const svg = el.querySelector("svg");
        // Set/override SVG tag attributes
        if (width) {
          svg.setAttribute("width", width);
        }
        if (height) {
          svg.setAttribute("height", height);
        }
        unwrapNode(el);
      }}
    />
  );
};

/// Assigns `changes` into `state` and returns a new object iff any values of
/// `changes` are !== the corresponding values in `state`.
/// Helpful to prevent unnecessary re-renders in hyperapp
export function mergeState(state, changes) {
  for (const key of Object.keys(changes)) {
    if (changes[key] !== state[key]) {
      return {
        ...state,
        ...changes,
      };
    }
  }
}

export function mergeStateAction(changes) {
  return (state, actions) => mergeState(state, changes);
}
